import type { FC } from "react"
import type { PostImageResponse, PostCampingSiteResponse } from "@/types/domain"
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination } from "swiper/modules"
import { MapPin } from "lucide-react"
import "swiper/css"
import "swiper/css/pagination"

type PostContentProps = {
  title: string
  content: string
  images: PostImageResponse[]
  tags: string[]
  campingSites?: PostCampingSiteResponse[]
}

const PostContent: FC<PostContentProps> = ({ title, content, tags, images, campingSites }) => {
  return (
    <div className="post-body">
      <h1 className="post-title">{title}</h1>
      <p className="post-text">
        {content}
      </p>

      {images.length > 0 && (
        <div className="post-image-slider">
          <Swiper
            modules={[Pagination]}
            pagination={{ clickable: true }}
            spaceBetween={0}
            slidesPerView={1}
            className="w-full h-full bg-gray-100"
          >
            {images.map(image => (
              <SwiperSlide key={image.id}>
                <img
                  src={image.url}
                  alt="Post content"
                  className="post-image"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}

      {/* Linked Camping Sites */}
      {campingSites && campingSites.length > 0 && (
        <div className="post-camping-sites-section">
          <h3 className="post-section-title">관련 장소</h3>
          <div className="post-camping-sites-list">
            {campingSites.map(site => (
              <div 
                key={site.id} 
                className="camping-site-card"
              >
                <div className="camping-site-icon">
                  <MapPin size={18} />
                </div>
                <div className="camping-site-info">
                  <div className="camping-site-name">{site.name}</div>
                  <div className="camping-site-address">{site.address}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {tags.length > 0 && (
        <div className="post-tags">
          {tags.map(tag => (
            <span
              key={tag}
              className="post-tag"
            >
              #{tag}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

export default PostContent
